<template>
<div class="chapter">
<div class="inner_page">
<p class="title">IMAGES OF WAR</p>
<p class="title1">THE BEF IN 1917</p>
<p class="title2">Arras, Vimy, Messines,</p>
<p class="title2">Passchendaele and Cambrai</p>
<p class="title3">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half_Title.vue?53d65099